import request from '@/utils/request'

let LooprebateApi = {
  
    index(data) {
        return request._post('/shop/plus.looprebate.Looprebate/index', data);
    },
    /*设置*/
    setting(data) {
        return request._post('/shop/plus.looprebate.Looprebate/setting', data);
    },
    getSetting(data) {
        return request._get('/shop/plus.looprebate.Looprebate/getSetting', data);
    },
    // 添加循环返利
    addLooprebate(data) {
        return request._get('/shop/plus.looprebate.Looprebate/addLooprebate', data);
    },
     // 修改循环返利
    updLooprebate(data) {
        return request._get('/shop/plus.looprebate.Looprebate/updLooprebate', data);
    },
     // 删除循环返利
     deleteLooprebate(data) {
        return request._get('/shop/plus.looprebate.Looprebate/deleteLooprebate', data);
    },
    record(data) {
        return request._get('/shop/plus.looprebate.Looprebate/record', data);
    },
}
export default LooprebateApi;



// WEBPACK FOOTER //
// ./src/api/looprebate.js